<template>
  <v-app class="add--vehicle">
    <v-dialog v-model="dialogVehicle" width="900px">
      <v-card class="dlg-card">
        <dialog-header
          title="Vehicle & User Details"
          icon="mdi-card-account-details-outline"
          @close="$emit('updateDialogVehicleStatus', false)"
        />
        <v-divider></v-divider>
        <v-card-text class="dlg-body vv-body">
          <!-- Eligibility banner -->
          <div class="vv-banner">
            <div class="vv-banner-badge">
              <v-icon color="white" size="20">mdi-shield-check</v-icon>
            </div>
            <div>
              <div class="vv-banner-title">Qualified For Assessment</div>
              <div class="vv-banner-sub">
                This policy meets the requirements and is eligible for
                assessment.
              </div>
            </div>
          </div>

          <v-row>
            <v-col cols="12" md="6">
              <div class="vv-card">
                <div class="vv-card-head">
                  <div class="vv-head-icon">
                    <v-icon color="primary" size="18"
                      >mdi-account-outline</v-icon
                    >
                  </div>
                  <span class="vv-card-title"
                    >Insured &amp; Policy Information</span
                  >
                </div>
                <div v-for="(row, i) in insuredInfo" :key="i" class="vv-row">
                  <div class="vv-row-icon">
                    <v-icon color="primary" size="16">{{ row.icon }}</v-icon>
                  </div>
                  <span class="vv-label">{{ row.label }}</span>
                  <span class="vv-value">{{ row.value }}</span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="vv-card">
                <div class="vv-card-head">
                  <div class="vv-head-icon">
                    <v-icon color="primary" size="18"
                      >mdi-file-document-outline</v-icon
                    >
                  </div>
                  <span class="vv-card-title">Policy Details</span>
                </div>
                <div v-for="(row, i) in policyDetails" :key="i" class="vv-row">
                  <div class="vv-row-icon">
                    <v-icon color="primary" size="16">{{ row.icon }}</v-icon>
                  </div>
                  <span class="vv-label">{{ row.label }}</span>
                  <span class="vv-value">{{ row.value }}</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dlg-actions vv-actions">
          <v-spacer></v-spacer>
          <v-btn
            id="addVehicleBtn"
            color="primary"
            class="px-8"
            @click="addVehicleDetails"
          >
            Add Vehicle
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar top right v-model="snackbar" :color="snackbarColor">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapState } from 'vuex'
import axios from 'axios'
import validation from '@/utils/Validations'
import store from '@/store'
import DialogHeader from '@/components/DialogHeader'

export default {
  components: { DialogHeader },
  emits: ['updateDialogVehicleStatus'],
  props: {
    dialogVehicle: {
      type: Boolean,
      required: true,
    },
    vehicleDetails: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    valid: false,
    regNo: '',
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: '',
    dialog: false,
    dialogInvite: false,
    ...validation,
  }),

  computed: {
    ...mapState(['loading']),
    insuredInfo() {
      const d = this.vehicleDetails
      return [
        {
          icon: 'mdi-account-multiple-outline',
          label: "Insured's Name",
          value: this.scanObject(d, 'client.name'),
        },
        {
          icon: 'mdi-phone-outline',
          label: "Insured's Phone Number",
          value: this.scanObject(d, 'client.phoneNumber'),
        },
        {
          icon: 'mdi-card-account-details-outline',
          label: 'Reg No',
          value: this.scanObject(d, 'vehicle.registrationNumber'),
        },
        {
          icon: 'mdi-file-document-outline',
          label: 'Policy No',
          value: this.scanObject(d, 'policy.policyNumber'),
        },
        {
          icon: 'mdi-shield-check-outline',
          label: 'Sum Assured',
          value: this.scanObject(d, 'policy.sumInsured'),
        },
        {
          icon: 'mdi-seal-variant',
          label: 'Endorsement Number',
          value: this.scanObject(d, 'policy.endorsementNumber'),
        },
      ]
    },
    policyDetails() {
      const d = this.vehicleDetails
      return [
        {
          icon: 'mdi-calendar-outline',
          label: 'Policy Type',
          value: this.scanObject(d, 'policy.coverType'),
        },
        {
          icon: 'mdi-calendar-text-outline',
          label: 'Policy Description',
          value: this.scanObject(d, 'policy.description'),
        },
        {
          icon: 'mdi-calendar-start',
          label: 'Policy Period from',
          value: this.scanObject(d, 'policy.effectiveFromDate'),
        },
        {
          icon: 'mdi-calendar-end',
          label: 'Policy Period to',
          value: this.scanObject(d, 'policy.effectiveToDate'),
        },
        {
          icon: 'mdi-calendar-refresh-outline',
          label: 'Renewal Date',
          value: this.scanObject(d, 'policy.renewalDate'),
        },
      ]
    },
  },

  methods: {
    addVehicleDetails() {
      this.$emit('updateDialogVehicleStatus', false)
      let vehicleDetailsPayload = this.vehicleDetails
      vehicleDetailsPayload.region =
        store.getters['auth/authenticatedUser']['custom:region']
      axios
        .post(
          `/motor-assessment/api/booking?userId=${this.$store.state.auth.user.sub}`,
          vehicleDetailsPayload
        )
        .then((res) => {
          if (res.data.success === true) {
            this.snackbar = true
            this.snackbarMessage = 'This vehicle was added successfully'
            this.snackbarColor = 'success'
            location.reload()
          } else {
            this.snackbar = true
            this.snackbarMessage = res.data.msg
            this.snackbarColor = 'error'
          }
        })
        .catch(() => {
          this.snackbar = true
          this.snackbarMessage = 'Oops! Something went wrong!'
          this.snackbarColor = 'error'
        })
    },
  },
}
</script>
<style scoped>
.add--vehicle {
  height: 0;
  float: right;
}

.vehicle--search__input {
  width: 300px;
}

/* Eligibility banner */
.vv-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #eef4fd;
  border: 1px solid #dce8fb;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 16px;
}
.vv-banner-badge {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.vv-banner-title {
  color: #034ea2;
  font-weight: 800;
  font-size: 15px;
  line-height: 1.3;
}
.vv-banner-sub {
  color: #5b6b82;
  font-size: 13px;
}

/* Info cards */
.vv-card {
  border: 1px solid #e8edf5;
  border-radius: 14px;
  padding: 14px 16px;
  height: 100%;
}
.vv-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}
.vv-head-icon {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #eaf1fb;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vv-card-title {
  color: #0f2a55;
  font-weight: 800;
  font-size: 15px;
}
.vv-row {
  display: grid;
  grid-template-columns: 26px minmax(96px, auto) 1fr;
  align-items: center;
  gap: 10px;
  padding: 10px 2px;
  border-bottom: 1px solid #eef2f8;
}
.vv-row:last-child {
  border-bottom: none;
}
.vv-row-icon {
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  border-radius: 7px;
  background: #f2f6fc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vv-label {
  color: #6b7a90;
  font-size: 13px;
}
.vv-value {
  color: #034ea2;
  font-weight: 700;
  font-size: 13px;
  text-align: right;
  overflow-wrap: break-word;
}
.vv-actions {
  padding-top: 12px;
  padding-bottom: 16px;
}
</style>
